export default [{
        path: '/',
        name: 'home',
        component: () =>
            import ('@/views/main/Main.vue'),
        meta: {},
    },
    {
        path: '/map',
        name: 'map',
        component: () =>
            import ('@/views/main/map/NewMap.vue'),
        meta: {},
    },
    {
        path: '/apps/asset/preview/:id',
        name: 'apps-asset-preview',
        component: () =>
            import ('@/views/apps/asset/asset-preview/AssetPreview.vue'),
    },
    {
        path: '/customer/list',
        name: 'list-customer',
        component: () =>
            import ('@/views/main/customer/ListCustomer.vue'),
    },
    {
        path: '/customer/register/:id?',
        name: 'register-customer',
        component: () => import('@/views/main/customer/RegisterCustomer.vue'),
    },
    {
        path: '/dealer/list',
        name: 'list-dealer',
        component: () =>
            import ('@/views/main/dealer/ListDealer.vue'),
    },
    {
        path: '/dealer/register/:id?',
        name: 'register-dealer',
        component: () => import('@/views/main/dealer/RegisterDealer.vue'),
    },
    {
        path: '/user/list',
        name: 'list-user',
        component: () =>
            import ('@/views/main/user/UsersList.vue'),
    },
    {
        path: '/user/register/:id?',
        name: 'register-user',
        component: () => import('@/views/main/user/RegisterUser.vue'),
    },
    {
        path: '/device/list',
        name: 'list-device',
        component: () =>
            import ('@/views/main/device/device-list/ListDevice.vue'),
    },
    {
        path: '/device/register/:id?',
        name: 'register-device',
        component: () => import('@/views/main/device/device-register/RegisterDevice.vue'),
    },
    {
        path: '/device/install/:id',
        name: 'install-device',
        component: () => import('@/views/main/device/device-install/InstallDevice.vue'),
    },
    {
        path: '/device/uninstall/:id',
        name: 'uninstall-device',
        component: () => import('@/views/main/device/device-uninstall/UninstallDevice.vue'),
    },
    {
        path: '/device/search',
        name: 'list-all-device',
        component: () =>
            import ('@/views/main/device/device-all-search/ListAllDevice.vue'),
    },
    {
        path: '/asset/preview/:id',
        name: 'preview-asset',
        component: () => import('@/views/main/asset/asset-preview/AssetPreview.vue'),
    },
    {
        path: '/asset/register/:id?',
        name: 'register-asset',
        component: () => import('@/views/main/asset/asset-register/RegisterAsset.vue'),
    },
    {
        path: '/queries/telemetry/:id',
        name: 'queries-telemetry',
        component: () => import('@/views/main/queries/telemetry/GraphicBoardDiary.vue'),
    },
    {
        path: '/queries/telemetry/GraphicTelemetryMonth/:id',
        name: 'queries-month',
        component: () => import('@/views/main/queries/telemetry/GraphicTelemetryMonth.vue'),
    },
    {
        path: '/queries/telemetry/payload/:id?',
        name: 'queries-payload',
        component: () => import('@/views/main/queries/payload/PayloadReport.vue'),
    },
    {
        path: '/queries/telemetry/payload-analytics/:id?',
        name: 'queries-payload-analytics',
        component: () => import('@/views/main/queries/payload-analytics/PayloadAnalyticsReport.vue'),
    },
    {
        path: '/management/fuelling/register/:id?',
        name: 'register-fuelling',
        component: () => import('@/views/main/management/fuelling/RegisterFuelling.vue'),
    },
    {
        path: '/management/fuelling/list',
        name: 'list-fuelling',
        component: () => import('@/views/main/management/fuelling/FuellingList.vue'),
    },
    {
        path: '/management/fuellingbulk',
        name: 'fuelling-bulk',
        component: () => import('@/views/main/management/fuelling/FuellingImport.vue'),
    },
    {
        path: '/device/registerbulk/list',
        name: 'device-bulk',
        component: () => import('@/views/main/device/device-register/RegisterDeviceBulk.vue'),
    },
    {
        path: '/fence/registerfence/:id?',
        name: 'fence-register',
        component: () => import('@/views/main/fence/RegisterFence.vue'),
    },
    {
        path: '/fence/management',
        name: 'fence-management',
        component: () => import('@/views/main/fence/FenceManagement.vue'),
    },
    {
        path: '/fence/report',
        name: 'fence-report',
        component: () => import('@/views/main/fence/FenceReport.vue'),
    },
    {
        path: '/fence/tutorial',
        name: 'fence-tutorial',
        component: () => import('@/views/main/fence/FenceTutorial.vue'),
    },
    {
        path: '/point/registerpoint/:id?',
        name: 'point-register',
        component: () => import('@/views/main/point/RegisterPoint.vue'),
    },

    
    {
        path: '/driver/list',
        name: 'list-driver',
        component: () =>
            import ('@/views/main/driver/driver-list/DriversList.vue'),
    },
    {
        path: '/driver/register/:id?',
        name: 'register-driver',
        component: () => import('@/views/main/driver/driver-register/RegisterDriver.vue'),
    },
    {
        path: '/driver/driverattribute',
        name: 'list-driver-attribute',
        component: () =>
            import ('@/views/main/driver/DriverAttribute.vue'),
    },

    {
        path: '/alarms/settings/:id',
        name: 'settings-alarms',
        component: () => import('@/views/main/alarms/AlarmSettings.vue'),
    },

    {
        path: '/alarms/customer',
        name: 'customer-alarms',
        component: () => import('@/views/main/alarms/AlarmSettingsCustomer.vue'),
    },

    {
        path: '/management/preventivemaintenanceplan/register/:id?',
        name: 'register-maintenance-plan',
        component: () => import('@/views/main/management/maintenancePlan/RegisterMaintenancePlan.vue'),
    },
    {
        path: '/management/maintenancerecord/register/:id?',
        name: 'maintenance-record',
        component: () =>
            import ('@/views/main/management/maintenanceRecord/MaintenanceRecord.vue'),
    },
    {
        path: '/management/maintenancerecord/list',
        name: 'list-maintenance',
        component: () =>
            import ('@/views/main/management/maintenanceRecord/MaintenanceList.vue'),
    },

    {
        path: '/management/preventivemaintenanceplan/list',
        name: 'list-maintenance-plan',
        component: () =>
            import ('@/views/main/management/maintenancePlan/MaintenancePlanList.vue'),
    },

    {
        path: '/management/maintenance/:id',
        name: 'maintenance',
        component: () => import('@/views/main/management/maintenance/Maintenance.vue'),
    },

    {
        path: '/management/maintenanceassets/:id',
        name: 'maintenance-assets',
        component: () => import('@/views/main/management/maintenance/MaintenanceAssets.vue'),
    },

    {
        path: '/management/group/list',
        name: 'list-group',
        component: () =>
            import ('@/views/main/management/group/GroupList.vue'),
    },

    {
        path: '/management/group/register/:id?',
        name: 'register-group',
        component: () => import('@/views/main/management/group/RegisterGroup.vue'),
    },
    
    {
        path: '/queries/workstatus/:id',
        name: 'queries-weekly-work-status',
        component: () => import('@/views/main/queries/workStatus/weeklyWorkStatus.vue'),
    },

    {
        path: '/queries/geodata/:id',
        name: 'geo-data',
        component: () => import('@/views/main/queries/geoData/geoData.vue'),
    },
    {
        path: '/queries/telemetry/TelemetryTableHistory/:id',
        name: 'telemetry-table',
        component: () => import('@/views/main/queries/telemetry/TelemetryTableHistory.vue'),
    },

    {
        path: '/ControlFleet/dashboards',
        name: 'assets-dashboards',
        component: () => import('@/views/main/dashboards/dashboards.vue'),
    },

    {
        path: '/reports/usage',
        name: 'report-usage',
        component: () => import('@/views/main/reports/UsageReport.vue')
    },
    {
        path: '/reports/fleet-dashboard',
        name: 'fleet-dashboard',
        component: () => import('@/views/main/reports/fleet/FleetDashboard.vue')
    },
    {
        path: '/manufacturer/search',
        name: 'list-manufacturer',
        component: () =>
            import ('@/views/main/asset_manufacturer/ManufacturersList.vue'),
    },
    {
        path: '/manufacturer/register/:id?',
        name: 'register-manufacturer',
        component: () => import('@/views/main/asset_manufacturer/RegisterManufacturer.vue'),
    },
    {
        path: '/model/search',
        name: 'list-model',
        component: () =>
            import ('@/views/main/asset_models/ModelsList.vue'),
    },
    {
        path: '/model/register/:id?',
        name: 'register-model',
        component: () => import('@/views/main/asset_models/RegisterModel.vue'),
    },
    {
        path: '/failure/customer',
        name: 'customer-failure',
        component: () => import('@/views/main/queries/failure/FailureReport.vue'),
    },

    {
        path: '/customer/register/dns/:id?',
        name: 'register-customer-dns',
        component: () => import('@/views/main/customer/RegisterCustomerDns.vue'),
    },
    {
        path: '/customer/dns/search',
        name: 'list-customer-dns',
        component: () =>
            import ('@/views/main/customer/ListCustomerDns.vue'),
    },
    {
        path: '/queries/telemetry/summary/:id',
        name: 'telemetry-summary',
        component: () => import('@/views/main/reports/TelemetrySummaryReport.vue'),
    },
    {
        path: '/maintenance/maintenancetime',
        name: 'maintenance-time',
        component: () =>
            import ('@/views/main/management/maintenanceRecord/MaintenanceTime.vue'),
    },

    {
        path: '/safespot/search',
        name: 'safespot',
        component: () => import('@/views/main/safe-spot/SafeSpot.vue'),
    },
    {
        path: '/device/installations',
        name: 'devices-installations',
        component: () => import('@/views/main/device/DevicesInstallationsList.vue'),
    },
    {
        path: '/operationaltime/list',
        name: 'operational-time',
        component: () =>
            import ('@/views/main/operational-time/OperationalTimeFleet.vue'),
    },
    {
        path: '/apps/asset/summary/:id',
        name: 'apps-asset-summary',
        component: () =>
            import ('@/views/main/asset/summary/AssetSummary.vue'),
    },
    {
        path: '/asset/newmap',
        redirect: { name: 'map' },
    },
    {
        path: '/adm/asset/model-limits',
        name: 'list-model-limits',
        component: () => import('@/views/main/asset-model-limit/ListAssetModelLimit.vue'),
    },
    {
        path: '/adm/asset/model-limit/:id?',
        name: 'register-model-limit',
        component: () => import('@/views/main/asset-model-limit/RegisterAssetModelLimit.vue'),
    },
    {
        path: '/adm/inbound-integrations/list',
        name: 'inbound-integrations-list',
        component: () => import('@/views/main/inbound-integrations/ListInboundIntegrations.vue'),
    },
    {
        path: '/adm/dtc/create',
        name: 'create-dtc-table',
        component: () => import('@/views/main/dtc/CreateDtc.vue'),
    },
    {
        path: '/adm/dtc/edit/:id',
        name: 'edit-dtc-table',
        component: () => import('@/views/main/dtc/EditDtc.vue'),
    },
    {
        path: '/adm/dtc/list',
        name: 'dtc-list',
        component: () => import('@/views/main/dtc/ListDtc.vue'),
    },
    {
        path: '/adm/dtc/coverage',
        name: 'dtc-coverage',
        component: () => import('@/views/main/dtc/CoverageDtc.vue'),
    },
    {
        path: '/adm/oauth-callback',
        name: 'oauth-callback',
        component: () => import('@/views/main/inbound-integrations/OAuthCallback.vue'),
        meta: {
            layout: 'full', 
        },
    },
]